export const initialState = () => ({
  collections: {
    academicYears: [],
    centers: [],
    status: [],
    municipalities: [],
    schools: []
  },
  isAdmin: false,
  filters: {
    academicYear: null,
    sieorRegId: null,
    center: null,
    municipality: null,
    status: null,
    numberTapRequest: null,
    requestType: null,
    school: null
  },
  hasAccessLevel: false,
  results: [],
  pagination: {
    currentPage: 1,
    totalItemCount: 0,
    pageCount: 1,
    count: 0,
    pageSize: 10
  },
  centerDisabled: false,
  districtDisabled: false,
  municipalityDisabled: false,
  schoolDisabled: false,
  studentSIE: null,
  currentStatus: null
});

export default initialState();
